import React, { ChangeEventHandler, DragEventHandler, ReactNode } from "react";

interface GenericDropZoneProps {
	content: ReactNode;
	onDrop: DragEventHandler;
	onDragOver: DragEventHandler;
	onFileChange: ChangeEventHandler;
}

function GenericDropZone({
	content,
	onDrop,
	onDragOver,
	onFileChange,
}: GenericDropZoneProps) {
	return (
		<div className="mx-auto flex w-[500px] flex-col space-y-10 pt-12">
			<div
				className="flex h-full flex-col space-y-4 rounded border border-neutral-200 p-4 bg-white/20"
				onDrop={onDrop}
				onDragOver={onDragOver}
			>
				<div className="flex items-center justify-center w-full">
					<label
						htmlFor="dropzone-file"
						className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-white/30 hover:bg-white/40"
					>
						{content}
						<input
							id="dropzone-file"
							type="file"
							accept="application/pdf application/doc"
							multiple
							onChange={onFileChange}
							className="hidden"
						/>
					</label>
				</div>
				<p className="mt-2 px-8 text-xs text-gray-500 dark:text-gray-400">
					Ceci est un environnement de démonstration, aucun fichier n'est
					sauvegardé.
				</p>
				<p className="mt-2 px-8 text-xs text-gray-500 dark:text-gray-400">
					Formats bientot pris en charge : DOC, PPT, XLS.
				</p>
			</div>
		</div>
	);
}

export function LoadingDropZone({}): ReactNode {
	const content = (
		<div className="flex flex-col items-center justify-center pt-5 pb-6">
			<svg
				aria-hidden="true"
				role="status"
				className="inline w-12 h-12 mr-3 text-primary-400 animate-spin"
				viewBox="0 0 100 101"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
					fill="#E5E7EB"
				/>
				<path
					d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
					fill="currentColor"
				/>
			</svg>
			<p className="text-xs text-gray-500 dark:text-gray-400 mt-10">
				Chargement et traitement des documents...
			</p>
		</div>
	);
	return (
		<GenericDropZone
			content={content}
			onDrop={() => {}}
			onDragOver={() => {}}
			onFileChange={() => {}}
		/>
	);
}

interface DropZone {
	onDrop: DragEventHandler;
	onDragOver: DragEventHandler;
	onFileChange: ChangeEventHandler;
}
export function DropZone({ onDrop, onDragOver, onFileChange }: DropZone) {
	const content = (
		<div className="flex flex-col items-center justify-center pt-5 pb-6">
			<svg
				aria-hidden="true"
				className="w-10 h-10 mb-3 text-gray-400"
				fill="none"
				stroke="currentColor"
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="2"
					d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
				/>
			</svg>
			<p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
				<span className="font-semibold">
					Cliquer pour charger un ou plusieurs documents
				</span>{" "}
				ou faites les glisser ici.
			</p>
			<p className="text-xs text-gray-500 dark:text-gray-400">
				Formats pris en charge : PDF uniquement.
			</p>
		</div>
	);
	return (
		<GenericDropZone
			content={content}
			onDrop={onDrop}
			onDragOver={onDragOver}
			onFileChange={onFileChange}
		/>
	);
}
